import classNames from 'classnames'
import { WebQuote } from '../../../../../../server/utils/web/buildWebOffer'
import sortWebQuotes from '../../../../../../server/utils/web/sortWebProducts'
import { WEB_PRODUCTS } from '../../../../../../utils/consts'
import Button from '../../../../../Button'
import Svg from '../../../../../Svg'
import Text from '../../../../../Text'
import { WebProductCard } from '../../../productCards/WebProductCard'
import { WebStep01IndexProductDetails } from '../../card-details/WebStep01IndexProductDetails'
import logoProduitMySofieSvg from './imgs/logoMyBooster.svg'
import yellowCheckBox from './imgs/yellowCheckbox.svg'

export const WebStep01IndexPinkSection = (props: {
  selectedIndex?: number
  onNextButtonClick: () => void
  quotes: WebQuote[]
  showDetailProduct: (index: number) => void
}) => (
  <div
    className={classNames(
      'w-full',
      //'bg-purple-300',
      // Vertical on mobile, horizontal on tablet
      'flex flex-col sm:flex-row',
      // Limit width
      'sm:px-8 w-full max-w-[315px] sm:max-w-[900px] md:max-w-[1350px]',
      // Tablet: spacing between columns
      'sm:space-x-12',
      'md:space-x-16',
      'lg:space-x-10',
      'xl:space-x-12',
      '2xl:space-x-32',
      // Top margin
      'mt-7 sm:mt-14',
      // Bottom margin
      { 'mb-8': props.selectedIndex === undefined },
      // Prevent text going below the background
      'z-10'
    )}
  >
    <TextSection onNextButtonClick={props.onNextButtonClick} />
    <ProductsSection
      onNextButtonClick={props.onNextButtonClick}
      quotes={sortWebQuotes(props.quotes)}
      selectedIndex={props.selectedIndex}
      showDetailProduct={props.showDetailProduct}
    />
  </div>
)

const TextSection = (props: { onNextButtonClick: () => void }) => (
  <div
    className={classNames(
      //'bg-orange-400',
      'flex-1',
      'ml-4',
      'text-white',
      // Lower logo
      'mt-4 sm:mt-12',
      // maximum size of text on the left so that it fits on the page with the products on the right
      'max-w-[800px] sm:max-w-[230px] md:max-w-[400px] lg:max-w-[600px] xl:max-w-[750px]'
      //'mt-4 sm:mt-12',
      // maximum size of text on the left so that it fits on the page with the products on the right
      //'max-w-[800px] sm:max-w-[230px] md:max-w-[400px] lg:max-w-[600px] xl:max-w-[750px]'
    )}
  >
    {/* Logo */}
    <div className="flex flex-col items-center sm:flex-row sm:items-start">
      <div className="mb-6 mr-5" style={{ width: 73, height: 73 }}>
        <Svg alt="logoProduitMySofie" height={73} src={logoProduitMySofieSvg} width={73} />
      </div>

      {/* Title */}
      <div className="text-center sm:text-left">
        <div className="text-[40px] lg:text-[60px] font-bold sm:mt-2 mb-3 sm:mb-5">myBooster</div>
        <div className="md:text-base lg:text-xl">votre surcomplémentaire santé.</div>
      </div>
    </div>

    {/* Text */}
    <div
      className={classNames(
        'text-center sm:text-start',
        'md:text-base lg:text-xl',
        'mt-9',
        'sm:max-w-[360px] lg:max-w-[466px] xl:max-w-[500px]'
      )}
    >
      <div className="mb-5 text-center sm:text-start">
        Pour que votre santé{' '}
        <span className="font-bold">
          n&apos;affecte pas votre budget, choisissez l&apos;offre adaptée à vos besoins{' '}
        </span>{' '}
        et réduisez votre reste à charge jusqu&apos;à 75%.
      </div>

      <div className="mb-5 text-start">
        <BulletItems />
      </div>

      <div className="flex justify-center sm:justify-start mt-6 mb-10 sm:mt-20">
        <Button onClick={props.onNextButtonClick} text="Réaliser mon devis" small={true} />
      </div>
    </div>
  </div>
)

const BulletItems = () => {
  return (
    <div className="mb-5 text-start">
      <div className="flex flew-row">
        <CheckBoxImage />
        <div className="mt-1 sm:mt-0">
          <Text>
            Quelle que soit <span className="font-bold">votre mutuelle</span>
          </Text>
        </div>
      </div>

      <div className="flex flew-row min-w-[20px]">
        <CheckBoxImage />
        <div className="mt-1 sm:mt-0">
          <Text>
            Pour <span className="font-bold">toutes les personnes</span> que vous souhaitez
          </Text>
        </div>
      </div>

      <div className="flex flew-row">
        <CheckBoxImage />
        <div className="mt-1 sm:mt-0">
          <Text>
            <span className="font-bold">Selon vos besoins actuels et à venir</span>
          </Text>
        </div>
      </div>

      <div className="flex flew-row">
        <CheckBoxImage />
        <div className="mt-1 sm:mt-0">
          <Text>
            Avec <span className="font-bold">suivi simplifié</span> au sein de notre app
          </Text>
        </div>
      </div>
    </div>
  )
}

const CheckBoxImage = () => {
  return (
    <div className="mr-4 mt-1 min-w-[20px]">
      <Svg alt="checkbox" height={20} src={yellowCheckBox} width={20} />
    </div>
  )
}
const ProductsSection = (props: {
  onNextButtonClick: () => void
  quotes: WebQuote[]
  selectedIndex?: number
  showDetailProduct: (index: number) => void
}) => (
  <div className="w-full max-w-[320px] lg:max-w-[500px] space-y-3 mt-0 sm:mt-5 md:mt-12 lg:mt-0">
    {sortWebQuotes(props.quotes).map(
      (quote, index) =>
        (props.selectedIndex === undefined || props.selectedIndex === index) && (
          <WebProductCard
            key={quote.product.id}
            onClick={() => props.showDetailProduct(index)}
            quote={quote}
            isOpen={props.selectedIndex === index}
          >
            <WebStep01IndexProductDetails
              onNextButtonClick={props.onNextButtonClick}
              productWeb={WEB_PRODUCTS[index]}
            />
          </WebProductCard>
        )
    )}
  </div>
)
